import { makeAutoObservable, reaction } from "mobx"

class PlayerStore {
  isInPosition = false
  positionData = {
    currentPosition: null,
    currentRotation: null,
    prevPosition: null
  }
  activeNote = ''
  activeSubmits = []
  isRobotActive = false
  isInForm = false
  isBlankVisible = false
  isBlankInPlayer = false
  isPenInPlayer = false
  formData = {
    name: "",
    email: "",
    message: ""
  }
  isPlayerClick = false

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.isInPosition,
      () => {
        if (this.isBlankInPlayer && this.isInPosition) {
          this.activeSubmits = ["Press '1' to fill out the form"]
          window.addEventListener("keydown", this.handelFormSubmit)
        } else {
          this.activeSubmits = []
          window.removeEventListener("keydown", this.handelFormSubmit)
        }
      }
    )
  }

  playerClick() {
    this.isPlayerClick = true
  }

  setPenToPlayer() {
    this.isPenInPlayer = true
  }

  clearForm() {
    this.formData = {
      name: "",
      email: "",
      message: ""
    }

    this.isBlankInPlayer = false
  }

  changeFormData(key,value) {
    if (!this.isPenInPlayer) return
    this.formData[key] = value
  }

  handelFormSubmit = (event) => {
    if (event.key === "1") {
      document.exitPointerLock();
      this.isInForm = true
    }
  };

  changeIsBlankInPlayer(val) {
    this.isBlankInPlayer = val
  }

  showBlank(){
    this.isBlankVisible = true
  }

  hideBlank(){
    this.isBlankVisible = false
  }

  showForm(){
    this.isInForm = true
  }

  hideForm(){
    this.isInForm = false
  }

  showRobot() {
    this.isRobotActive = true
  }

  hideRobot() {
    this.isRobotActive = false
  }

  setActiveSubmits(newValue) {
    this.activeSubmits = newValue
  }

  clearActiveSubmits(){
    this.activeSubmits = []
  }

  setActiveNote(note) {
    if (this.isInPosition) return
    this.activeNote = note
  }

  clearActiveNote(note) {
    if (this.isInPosition) return
    this.activeNote = ''
  }
  setPosition({currentPosition, prevPosition,   currentRotation}) {
    if (this.isInPosition) return
    this.setActiveNote("Click to stand up")
    this.isInPosition = true
    this.positionData = {
      currentPosition,
      prevPosition,
      currentRotation
    }

    const handleClick = (e) => {
      if (this.isInForm) return
      this.activeNote = ''
      this.isInPosition = false
      document.removeEventListener("click", handleClick);

      e.stopPropagation()
      e.preventDefault()
    };

    setTimeout(() => {
      document.addEventListener("click", handleClick);
    })
  }
}

export const playerStore = new PlayerStore();
